module.exports = __webpack_public_path__ + "img/product-management.850bbf21.svg";